import { render, staticRenderFns } from "./AttributeValue.vue?vue&type=template&id=442bd07e&scoped=true"
import script from "./AttributeValue.vue?vue&type=script&lang=js"
export * from "./AttributeValue.vue?vue&type=script&lang=js"
import style0 from "./AttributeValue.vue?vue&type=style&index=0&id=442bd07e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442bd07e",
  null
  
)

export default component.exports